import { PayloadAction } from '@reduxjs/toolkit';
import { IHighLightsRequest, IHighLightsResponse } from '@tacans/shared-marketplace-layer';
import { useCallback } from 'react';
import { useFetchUserList } from 'src/features/common/user/hooks/user-list.hooks';
import { useAppDispatch, useAppSelector } from 'src/hooks/app';
import {
    selectHighlightedCollectionsEntities,
    selectHighlightedCollectionsLoading,
} from '../ducks/highlighted-collections/highlighted-collections.selectors';
import { actions } from '../ducks/highlighted-collections/highlighted-collections.slice';
import { highlightedCollectionsFetchThunk } from '../ducks/highlighted-collections/highlighted-collections.thunk';

export const useHighlightedCollections = () => {
    const dispatch = useAppDispatch();
    const fetchUserList = useFetchUserList();

    const highlightedCollections = useAppSelector(selectHighlightedCollectionsEntities);
    const isLoading = useAppSelector(selectHighlightedCollectionsLoading);

    const fetch = useCallback(
        async (request: IHighLightsRequest) => {
            const { payload } = (await dispatch(
                highlightedCollectionsFetchThunk(request)
            )) as PayloadAction<IHighLightsResponse>;
            if (payload.collections) {
                const userIds = payload.collections.map((collection) => collection.ownerId);
                fetchUserList({ userIds });
            }
        },
        [dispatch, fetchUserList]
    );

    const clear = useCallback(() => {
        dispatch(actions.clear());
    }, [dispatch]);

    return { fetch, clear, highlightedCollections, isLoading };
};
